import { useEffect, useState } from "react";
import { ProductAdvancedFields } from "../../../../../../OBJRep/ProductAdvancedFields";
import { FROM_X_TO_Y_PROMOTION } from "../../../../CanvasViewer/EncarteConstants";
import { parsePrice } from "./price.utils";

const priceStringToNumber = (price) => {
  return Number(price.replace(",", "."));
};

const isPriceCheaper = (priceOne, priceTwo) => {
  return priceStringToNumber(priceOne) < priceStringToNumber(priceTwo);
};

const isPromotionPriceCheaper = (productAdvancedFields) => {
  return (
    productAdvancedFields.normalSellingPrice &&
    productAdvancedFields.promotionPrice &&
    isPriceCheaper(
      productAdvancedFields.promotionPrice,
      productAdvancedFields.normalSellingPrice,
    )
  );
};

export const useFromXToYModal = ({
  products,
  currentProductId,
  isOpen,
  onSave,
}) => {
  const [productAdvancedFields, setProductAdvancedFields] = useState(
    ProductAdvancedFields(),
  );

  useEffect(() => {
    if (!isOpen || !products?.length) return;

    const currentProduct = products[currentProductId];
    if (!currentProduct) return;

    setProductAdvancedFields(
      ProductAdvancedFields(
        currentProduct.promotionType,
        currentProduct.takeX,
        currentProduct.payY,
        currentProduct.normalSellingPrice,
        currentProduct.promotionPrice,
      ),
    );
  }, [isOpen, products, currentProductId]);

  const updateProductAdvancedFields = (info, value) => {
    setProductAdvancedFields((prev) => ({ ...prev, [info]: value }));
  };

  const save = () => {
    const normalSellingPrice = productAdvancedFields.normalSellingPrice;
    const promotionPrice = productAdvancedFields.promotionPrice;

    if (!isPriceCheaper(promotionPrice, normalSellingPrice)) return;

    onSave({
      promotionType: FROM_X_TO_Y_PROMOTION,
      normalSellingPrice,
      promotionPrice,
    });
  };

  return {
    productAdvancedFields,
    updateProductAdvancedFields,
    isPromotionPriceCheaper: isPromotionPriceCheaper(productAdvancedFields),
    parsePrice,
    save,
  };
};
